export const WWW_URL = "https://worldlinkmedical.com/";
export const SUPPORT_URL = {
  type: "email",
  link: "mailto:information@worldlinkmedical.com",
};

export const PROD_HOSTNAME = "research.worldlinkmedical.com";
export const DEV_HOSTNAME = "research.worldlinkmedical.com";

export const PROD_URL = `https://${PROD_HOSTNAME}`;
export const DEV_URL = `https://${DEV_HOSTNAME}`;

export const LOGO_SRC = "/img/logo/worldlink-medical-full-logo.png";
export const SMALL_LOGO_SRC = "/img/logo/worldlink-medical-logomark.png";

export const APP_TITLE = "WorldLink Research";

export const companyFeatures = {
  isWhiteLabel: true,
  enablePetalRoutes: true,
  enableSecondaryApps: false,
  workspace: {
    singleWorkspace: true,
  },
  auth: {
    enableSignUp: false,
    enableGoogleAuth: true,
    enableForgotPassword: true,
  },
  settings: {
    enableSettingsPage: true,
    canUpgradePlans: false,
    canLeaveWorkspace: false,
  },
  app: {
    canSeeOnboarding: true,
    isTrialExists: false,
    canInvite: false,
    canCreateOrg: false,
    showDocumentation: false,
    guests: {
      canSeeNotifications: true,
      enableDocumentViewer: true,
      enableDocumentActions: true,
      enableDocumentDownload: true,
      enableLookUpTab: true,
      enableAITable: false,
      enableAICreate: false,
    },
    skipSignUpSurvey: true,
  },
};

export const companySettings: {
  defaultAIModel: "gpt-4o-mini" | "gpt-4o";
  defaultMultiDocChatModel: "gpt-4o-mini-16k" | "gpt-4o";
} = {
  defaultAIModel: "gpt-4o-mini",
  defaultMultiDocChatModel: "gpt-4o-mini-16k",
};
